import { createApp } from 'vue'
import router from '@router'
import $store from '@store'
import request from '@utils/request'
import Icon from '@components/icon'
import antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.less'
import permission from '@utils/permission'
import utils from '@utils/utils'
import customComponents from '@/components'

export default function (component) {
    return createApp(component).
    use(router).
    use($store).
    use(request).
    use(antd).
    use(permission).
    use(utils).
    use(Icon).
    use(customComponents)
}
